import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import tw, { css, styled } from 'twin.macro';
import Layout from './Layout';
import SEO from './SEO';
import { contentStyles, Article, Container, Inner, Title } from '.';
import Breadcrumbs from './Breadcrumbs';
import ContentLabel from './ContentLabel';
import DateLabel from './DateLabel';
import ProgressBar from './ProgressBar';
import DateAndTimeToRead from './DateAndTimeToRead';
import ShareButton from './ShareButton';
import { TalentFacts, CompanyFacts } from './Factbox';
import RelatedRibbon from './RelatedRibbon';

const FactboxAndImage = tw.div`w-full flex sm:(flex-row justify-between items-start)`;

const VideoContainer = styled.div`
  ${tw`relative overflow-hidden w-full`};
  padding-bottom: 56.25%;
`;

const iframeStyles = tw`absolute inset-0 w-full h-full`;

const CaseLayout = ({
  title,
  date,
  dateTime,
  shortIntroNode,
  slug,
  expert,
  company,
  featuredMedia,
  videoEmbedUrl,
  model: { name },
  contentNode,
  seo,
  relatedPosts,
}) => (
  <Layout articleType={name}>
    <Article>
      <SEO {...seo} articleType={name} slug={slug} dateTime={dateTime} />
      <ProgressBar>
        <Container>
          <Inner mt>
            <ContentLabel label={name} />
            <Breadcrumbs post={{ title, slug, articleType: name }} />
            <Title>{title}</Title>
            <DateAndTimeToRead
              date={date}
              dateTime={dateTime}
              readingTimeText={contentNode.childMarkdownRemark.fields.readingTime.text}
            />
            {shortIntroNode && (
              <div
                css={[contentStyles, tw`text-lg font-medium mb-0 mt-0 sm:mt-0`]}
                dangerouslySetInnerHTML={{ __html: shortIntroNode.childMarkdownRemark.html }}
              />
            )}
          </Inner>
          <FactboxAndImage
            css={[expert && tw`flex-col-reverse`, company && tw`flex-col sm:(flex-col)`]}
          >
            {expert && <TalentFacts {...expert} />}
            <GatsbyImage
              image={expert?.techTalentImage.gatsbyImageData || featuredMedia?.gatsbyImageData}
              alt={title}
              tw="text-transparent"
            />
            {company && <CompanyFacts {...company} />}
          </FactboxAndImage>
          {contentNode && (
            <div
              css={contentStyles}
              dangerouslySetInnerHTML={{ __html: contentNode.childMarkdownRemark.html }}
            />
          )}
          {videoEmbedUrl && (
            <VideoContainer>
              <iframe
                src={videoEmbedUrl}
                frameBorder="0"
                border="0"
                css={iframeStyles}
                scrolling="no"
                mozallowfullscreen="1"
                webkitallowfullscreen="1"
                allowFullScreen="1"
                allow="autoplay"
                title="talented in denmark portrait"
              />
            </VideoContainer>
          )}
        </Container>
      </ProgressBar>
    </Article>
    <RelatedRibbon articleType={name} sameAsArticle={title} posts={relatedPosts} />
  </Layout>
);

export default CaseLayout;
